import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { resetPassword } from "../../../redux/auth/actions";
import { Button, Form } from "react-bootstrap";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { APP_CONST } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";

const ResetPassword = ({ show, handleClose, handleModalShow }) => {
  const [otp, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async () => {
    if (otp == "" || password == "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "All fields are mandatory");
    } else {
      setIsVerifying(true);
      const response = await resetPassword({
        otp,
        password,
      });
      setIsVerifying(false);
      if (response) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Password reset success");
        handleClose();
        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
      }
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas login-modal"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <Modal.Header
        closeButton
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
        closeVariant="black"
      >
        <Modal.Title style={{ color: "#013862" }}>Reset Password</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#013862" }}>
        <div className="login-section">
          <div className="Login-rightPart">
            <div className="form-steps">
              <h2 className="h2">Verify!</h2>
              <p>Please enter OTP you received on your mobile number</p>
              <Form>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicOTP"
                >
                  <Form.Control
                    type="text"
                    placeholder="Enter OTP*"
                    autoComplete="off"
                    onChange={(e) => setOtpValue(e.target.value)}
                  />
                </Form.Group>
                <Form.Group
                  className="mb-3 position-relative"
                  controlId="formBasicPassword"
                >
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter new password"
                    autoComplete="new-password"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <span
                    className="icon"
                    onClick={() => setShowPassword((s) => !s)}
                  >
                    {showPassword ? <IoMdEyeOff /> : <IoMdEye />}
                  </span>
                </Form.Group>
              </Form>

              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={isVerifying}
              >
                {!isVerifying ? "SUBMIT" : "SUBMITTING"}
              </Button>
              <div className="sign-up mt-4">
                Already a member?
                <br />
                <a
                  onClick={() => {
                    handleClose();
                    handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                  }}
                >
                  Log In here
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ResetPassword;
